import styled, { css } from 'styled-components';
import { MordenCard } from '../../../atoms/modern-card/modern-card';

export const Fieldset = styled(MordenCard)`
  margin-top: 12px;

  legend {
    font-weight: 700;
    font-size: 22px;
    margin-bottom: 16px;
    color: #18233A;
    letter-spacing: -0.3px;
  }

  .grid {
    display: grid;
    gap: 12px;
  }

  @media (min-width: 600px) {
    .grid-2 {
      grid-template-columns: 1fr 1fr;
    }

    .grid-3 {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export const InputWrap = styled.div`
  position: relative;

  label {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--muted);
    font-size: 14px;
    transition: all 0.15s ease;
    pointer-events: none;
    background: var(--card);
    padding: 0 6px;
  }

  input,
  select {
    width: 100%;
    height: 48px;
    border-radius: 10px;
    border: 1.5px solid #D9DDE3;
    padding: 0 14px;
    background: #fff;
    font-size: 15px;
    color: #18233A;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  input:hover,
  select:hover {
    border-color: #b0b5bd;
  }

  input:focus,
  select:focus {
    outline: 0;
    border-color: var(--blue);
    box-shadow: 0 0 0 3px rgba(40, 121, 254, 0.1);
  }

  input:not(:placeholder-shown) + label,
  input:focus + label,
  select:focus + label {
    top: 0;
    transform: translateY(-50%) scale(0.85);
    color: var(--muted);
    font-size: 13px;
  }

  @media (max-width: 380px) {
    input,
    select {
      height: 44px;
      font-size: 14px;
      padding: 0 12px;
    }
  }
`;

export const PaymentFieldset = styled(Fieldset)`
  overflow: hidden;

  .acc {
    display: grid;
    gap: 8px;
  }
`;

export const SecureCheckoutNote = styled.div`
  margin-top: 16px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
  letter-spacing: -0.1px;
`;

export const AccHeader = styled.button<{ active?: boolean }>`
  appearance: none;
  -webkit-appearance: none;
  border: 1.5px solid ${(p) => p.active ? 'var(--blue)' : 'var(--border)'};
  border-radius: 12px;
  min-height: 56px;
  padding: 12px 16px;
  background: #fff;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  width: 100%;
  transition: border-color 0.2s;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  color: #18233A;

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    min-width: 0;
  }

  .method-label {
    font-weight: 600;
    white-space: nowrap;
    font-size: 15px;
  }

  .dot {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    flex-shrink: 0;
    border: 2px solid var(--blue);
    transition: all 0.2s;
    ${(p) =>
      p.active &&
      css`
        background: var(--blue);
        box-shadow: inset 0 0 0 3px #fff;
      `}
  }

  &:hover {
    border-color: var(--blue);
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 380px) {
    padding: 10px 12px;
    min-height: 50px;
    font-size: 13px;

    .method-label {
      font-size: 13px;
    }

    .left {
      gap: 6px;
    }

    .dot {
      width: 16px;
      height: 16px;
    }
  }
`;

export const AccBody = styled.div`
  border: 1.5px solid var(--border);
  border-radius: 12px;
  padding: 20px 16px;
  background: #F4F5F7;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 380px) {
    padding: 14px 10px;
  }
`;

export const PayPalInfo = styled.div`
  background: #fff;
  border-radius: var(--radius-sm);
  padding: 14px;
  color: var(--muted);
  font-size: 14px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: start;
`;

export const PayRow = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
`;

export const CardGrid = styled.div`
  display: grid;
  gap: 10px;
  max-width: 100%;

  @media (min-width: 560px) {
    grid-template-columns: 1.5fr 1fr;
    .span-2 {
      grid-column: span 2;
    }
  }

  @media (max-width: 380px) {
    gap: 8px;
  }
`;

export const PayLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    height: 22px;
    object-fit: contain;
  }

  @media (max-width: 380px) {
    gap: 2px;

    img {
      height: 18px;
    }
  }
`;

export const PlaceOrder = styled.button<{
  background?: string;
  color?: string;
  enabled?: boolean;
}>`
  width: 100%;
  height: 54px;
  border-radius: 14px;
  border: 0;
  margin-top: 12px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.2px;
  background: ${(p) => p.background ?? '#00D95F'};
  opacity: ${(p) => (p.enabled ? '1' : '0.7')};
  color: ${(p) => p.color ?? '#fff'};
  cursor: ${(p) => (p.enabled ? 'pointer' : 'not-allowed')};
  transition: all 0.2s ease;

  &:hover {
    transform: ${(p) => (p.enabled ? 'translateY(-1px)' : 'none')};
    box-shadow: ${(p) => (p.enabled ? '0 4px 14px rgba(0, 0, 0, 0.15)' : 'none')};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ApplePayContainer = styled.div`
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ApplePayHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #111827;

  img {
    width: 18px;
    height: 18px;
  }
`;

export const ApplePayHint = styled.p`
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
`;

export const ApplePayButtonWrapper = styled.div`
  margin-top: 4px;
  max-width: 320px;

  /* faz o botão ocupar a largura toda do wrapper */
  .StripeElement {
    width: 100% !important;
  }
`;

export const AmazonPayBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  height: 44px;
  padding: 0 20px;
  border-radius: 8px;
  border: none;
  background: #ff9900;
  color: #111;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #e68a00;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    height: 16px;
  }
`;

export const PixInfo = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--muted);
  display: grid;
  gap: 4px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
